import React from "react";
import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import SocialUpdate from "../../social_update";
import ReaderQuestionDetails from "./reader_question_details";

export default GrComponentFactory.createClass({
  displayName: "ReaderQuestionNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape(GrPropTypes.communityQuestion()),
  },

  renderHeader() {
    const book = this.props.resource.book;
    return (
      <span>
        asked a question about <a className="gr-hyperlink gr-hyperlink--bold" href={book.bookUrl}>{book.title}</a>
      </span>
    );
  },

  render() {
    const body = <ReaderQuestionDetails
                 {...this.props.resource}
               />;
    return (
      <SocialUpdate
        header={this.renderHeader()}
        body={body}
        {...this.props}
      />
    );
  },
});
